import { render } from "./ResultsTable.vue?vue&type=template&id=c457eb62"
import script from "./ResultsTable.vue?vue&type=script&lang=ts"
export * from "./ResultsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script